module.exports = __webpack_public_path__ + "img/search-pages.4f3aba17.webp";